import {
  Bot, Code2, Layers, Home, Compass, PenTool, Hammer, TrendingUp,
  Cpu, Database, Cloud, Workflow, FileSearch, Boxes, MessageSquare, Plug,
} from "lucide-react";

export const NAV = [
  { label: "Home", to: "/" },
  { label: "Services", to: "/services" },
  { label: "SefKam Home", to: "/sefkam-home" },
  { label: "AI & Automation", to: "/ai-automation" },
  { label: "About", to: "/about" },
  { label: "Insights", to: "/blog" },
  { label: "Contact", to: "/contact" },
];

export const SERVICES = [
  {
    icon: Bot,
    title: "AI & Intelligent Automation",
    desc: "AI agents, intelligent workflows, LLM-powered applications, RAG systems, and business process automation.",
    to: "/ai-automation",
  },
  {
    icon: Code2,
    title: "Software Engineering",
    desc: "Scalable backend systems, APIs, microservices, cloud-native applications, and enterprise software.",
    to: "/software-engineering",
  },
  {
    icon: Layers,
    title: "Digital Transformation",
    desc: "Modernize legacy systems, automate operations, integrate platforms, and build scalable digital foundations.",
    to: "/services",
  },
  {
    icon: Home,
    title: "Smart Home Automation",
    desc: "AI-powered home automation connecting lights, fans, ACs, sensors, and other smart devices into one intelligent experience.",
    to: "/sefkam-home",
  },
];

export const AI_CAPABILITIES = [
  { icon: Bot, label: "AI Agents" },
  { icon: FileSearch, label: "RAG Applications" },
  { icon: Cpu, label: "LLM Integrations" },
  { icon: Workflow, label: "Workflow Automation" },
  { icon: MessageSquare, label: "Intelligent Assistants" },
  { icon: FileSearch, label: "Document Intelligence" },
  { icon: Plug, label: "API & Tool Integration" },
  { icon: Boxes, label: "Multi-Agent Systems" },
];

export const AI_FLOW = ["User", "AI Agent", "Knowledge", "Tools / APIs", "Business Systems", "Result"];

export const ENG_CAPABILITIES = [
  { icon: Code2, label: "Backend Engineering" },
  { icon: Boxes, label: "Microservices" },
  { icon: Plug, label: "REST APIs" },
  { icon: Cloud, label: "Cloud Architecture" },
  { icon: Database, label: "Database Design" },
  { icon: Workflow, label: "Event-driven systems" },
  { icon: Cpu, label: "DevOps" },
  { icon: Boxes, label: "Kubernetes" },
  { icon: TrendingUp, label: "CI/CD" },
  { icon: Layers, label: "Enterprise Integrations" },
];

export const TECH_BADGES = [
  "Go", "Java", "Spring Boot", "Quarkus", "React", "Angular",
  "PostgreSQL", "Docker", "Kubernetes", "AWS", "OpenShift",
];

export const PRINCIPLES = [
  { n: "01", title: "Business First", desc: "We solve business problems, not just technical problems." },
  { n: "02", title: "Engineering Excellence", desc: "Scalable, secure and maintainable systems." },
  { n: "03", title: "AI With Purpose", desc: "We apply AI where it creates measurable value." },
  { n: "04", title: "Build for Tomorrow", desc: "We design solutions that can evolve as your business grows." },
];

export const PROCESS = [
  { n: "01", icon: Compass, title: "Discover", desc: "Understand the problem and business objective." },
  { n: "02", icon: PenTool, title: "Design", desc: "Design the architecture and user experience." },
  { n: "03", icon: Hammer, title: "Build", desc: "Develop, integrate, test and deploy." },
  { n: "04", icon: TrendingUp, title: "Evolve", desc: "Monitor, improve and scale." },
];

export const USE_CASES = [
  {
    title: "AI Business Automation",
    problem: "Repetitive manual operations slow teams down and introduce errors.",
    solution: "AI agents and workflow automation that handle routine tasks end to end.",
    outcome: "Teams focus on higher-value work while processes run reliably.",
  },
  {
    title: "Smart Home Automation",
    problem: "Home devices live in disconnected apps with no shared intelligence.",
    solution: "A unified layer that connects lights, climate, sensors and security.",
    outcome: "One intelligent experience that adapts to daily routines.",
  },
  {
    title: "Enterprise Software",
    problem: "Off-the-shelf tools can't model how the business actually works.",
    solution: "Tailored backend systems, APIs and interfaces built to fit.",
    outcome: "Software that mirrors operations and scales with demand.",
  },
  {
    title: "Cloud Modernization",
    problem: "Legacy systems are costly to run and hard to change.",
    solution: "Cloud-native architecture, containers and event-driven design.",
    outcome: "Faster releases, better resilience and lower operational drag.",
  },
  {
    title: "Intelligent Customer Support",
    problem: "Support teams are overwhelmed by repetitive questions.",
    solution: "RAG assistants grounded in your own knowledge and tools.",
    outcome: "Faster, accurate answers with humans in the loop where it matters.",
  },
  {
    title: "Workflow Automation",
    problem: "Work is stuck moving between systems, forms and inboxes.",
    solution: "Automated pipelines connecting platforms and business logic.",
    outcome: "Fewer handoffs and a smoother path from request to result.",
  },
];

export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1737505599162-d9932323a889",
  smartHome: "https://images.unsplash.com/photo-1752262167753-37a0ec83f614?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzd8MHwxfHNlYXJjaHwxfHxzbWFydCUyMGhvbWUlMjBpbnRlcmlvcnxlbnwwfHx8fDE3ODYxNjgzNTJ8MA&ixlib=rb-4.1.0&q=85",
  engineering: "https://images.pexels.com/photos/3861972/pexels-photo-3861972.jpeg",
};
